<div class="flex flex-row h-full mic-login user-management-page">
  <div class="flex flex-col justify-center items-center h-full gap-16">
    <form [formGroup]="changePasswordForm">
      <div class="flex flex-col justify-center gap-4">
        <h2 class="page-title page-header-spacing" id="password-heading">{{ translationService.translate(title) }}</h2>
        @if (isFromResetPassword) {
        <span
          >{{ translationService.translate('plsEnterNewPasswordText') }} <b>{{ userName }}</b>
        </span>
        } @if (isLoading) {
        <mic-spinner ariaLabel="In Progress" color="accent" [strokeWidth]="5"></mic-spinner>
        } @if (!isFromResetPassword) {
        <mat-form-field class="editable-field">
          <mat-label id="old-password" class="title-label">{{ translationService.translate('oldPasswordText') }}*</mat-label>
          <input
            id="old-password-input"
            matInput
            #oldPasswordInput
            [type]="hideOld ? 'password' : 'text'"
            placeholder="{{ translationService.translate('oldPwdPlaceHolderText') }}"
            autocomplete="current-password"
            formControlName="oldPassword"
            (keydown.enter)="onChangePasswordSubmit($event)"
          />
          <button mat-icon-button matSuffix (click)="hideOld = !hideOld" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideOld">
            <mat-icon>{{ hideOld ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (changePasswordForm.get('oldPassword').hasError('required')) {
          <mat-error id="old-password-error">
            {{ translationService.translate('oldPoweredReqText') }}
          </mat-error>
          } @if (changePasswordForm.get('oldPassword').hasError('incorrectOldPassword')) {
          <mat-error id="incorrect-old-password-error">
            {{ translationService.translate('incorrectOldPasswordText') }}
          </mat-error>
          }
        </mat-form-field>
        }
        <mat-form-field class="editable-field">
          <mat-label id="new-password" class="title-label">{{ translationService.translate('newPasswordText') }}*</mat-label>
          <input
            id="new-password-input"
            matInput
            #newPasswordInput
            [type]="hideNew ? 'password' : 'text'"
            placeholder="{{ translationService.translate('newPwdPlaceHolderText') }}"
            autocomplete="current-password"
            formControlName="newPassword"
          />
          <button mat-icon-button matSuffix (click)="hideNew = !hideNew" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNew">
            <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (changePasswordForm.get('newPassword').hasError('required')) {
          <mat-error id="new-password-error">{{ translationService.translate('newPoweredReqText') }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="editable-field">
          <mat-label id="confirm-password" class="title-label">{{ translationService.translate('confirmPasswordText') }}*</mat-label>
          <input
            id="confirm-password-input"
            matInput
            #confirmPasswordInput
            [type]="hideConfirm ? 'password' : 'text'"
            placeholder="{{ translationService.translate('confirmPwdPlaceHolderText') }}"
            autocomplete="confirm-password"
            formControlName="confirmPassword"
            (keydown.enter)="onChangePasswordSubmit($event)"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hideConfirm = !hideConfirm"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideConfirm"
          >
            <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (changePasswordForm.get('confirmPassword').hasError('required')) {
          <mat-error id="confirm-password-error">{{ translationService.translate('confirmPoweredReqText') }}</mat-error>
          } @if (changePasswordForm.hasError('matching')) {
          <mat-error id="do-not-match-error">{{ translationService.translate('passwordDoNotMatchText') }}</mat-error>
          } @if (changePasswordForm.get('confirmPassword').hasError('sameAsOld')) {
          <mat-error class="password-error" id="new-password-match-old-error">
            <mat-icon style="font-size: 14px">info_outline</mat-icon> {{ translationService.translate('newPasswordSameAsOldText') }}
          </mat-error>
          }
        </mat-form-field>
        <div class="highlight-label" style="font-weight: 400; color: rgba(0, 0, 0, 0.89)">
          {{ translationService.translate('passwordContainText') }}
        </div>

        <div style="margin-left: 10px; margin-top: -25px">
          <ul>
            <li id="atleast-ten-char" [ngStyle]="{ color: checkMinLength(currentFocusInput) }" class="highlight-label">
              {{ translationService.translate('atLeastTenCharText') }}
            </li>

            <li class="highlight-label">{{ translationService.translate('atLeastThreeReqText') }}</li>
            <ul style="margin-top: 5px">
              <li [ngStyle]="{ color: checkPasswordCriteriaUpper(currentFocusInput) }" class="highlight-label">
                {{ translationService.translate('oneCapitalText') }}
              </li>
              <li [ngStyle]="{ color: checkPasswordCriteriaLower(currentFocusInput) }" class="highlight-label">
                {{ translationService.translate('oneSmallText') }}
              </li>
              <li [ngStyle]="{ color: checkPasswordCriteriaNumber(currentFocusInput) }" class="highlight-label">
                {{ translationService.translate('oneNumberText') }}
              </li>
              <li [ngStyle]="{ color: checkPasswordCriteriaSpecial(currentFocusInput) }" class="highlight-label">
                {{ translationService.translate('specialCharText') }}
              </li>
            </ul>
          </ul>
        </div>
        <div class="flex flex-row justify-between" [style]="isFromResetPassword ? 'margin-bottom: 20px' : 'margin-bottom: 0px'">
          <button id="cancel-button" mat-flat-button color="accent" class="mic-login-button btn-cancel" (click)="cancelClicked()">
            {{ translationService.translate('cancelLinkText') }}
          </button>
          <button
            id="submit-button"
            mat-flat-button
            color="primary"
            class="mic-login-button btn-primary"
            (click)="onChangePasswordSubmit($event)"
          >
            {{ translationService.translate('changePasswordText') }}
          </button>
        </div>
      </div>
    </form>
    @if (!isFromResetPassword) {
    <div class="flex flex-row items-center gap-4 mic-login-footer">
      <p>{{ translationService.translate('poweredByText') }}</p>
      <mic-logo type="group"></mic-logo>
    </div>
    }
  </div>
</div>
